import { styled } from "@mui/material/styles";
import { Box, Grid2, Stack, Typography } from "@mui/material";
import { East, NorthEast } from "@mui/icons-material";
import { colors, shadows } from "../../../theme/theme";

export const CardGridItem = styled(Grid2)({});

export const Card = styled(Box, {
  shouldForwardProp: (prop) => !["isClickable"].includes(prop),
})(({ theme, isClickable }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  cursor: isClickable ? "pointer" : "default",
  backgroundColor: "#fff",
  borderRadius: "30px",
  boxShadow: shadows.card,
  padding: theme.spacing(3),
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  [theme.breakpoints.up("sm")]: {
    minHeight: "300px",
    height: "100%",
  },
  [theme.breakpoints.down("sm")]: {
    height: "auto",
    marginBottom: theme.spacing(2),
  },
  ...(isClickable && {
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: shadows.cardHover,
    },
  }),
}));

export const CardHeader = styled(Stack)(({ theme }) => ({
  borderBottom: `1px solid ${colors.lightBorder}`,
  paddingBottom: theme.spacing(1),
}));

export const CardTitle = styled("h3")(({ theme }) => ({
  ...theme.heading2,
  [theme.breakpoints.down("md")]: {
    fontSize: 22,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 18,
  },
}));

export const NorthEastIcon = styled(NorthEast)({
  fontSize: "24px",
  color: colors.secondary,
});

export const CardBody = styled(Typography)(({ theme }) => ({
  ...theme.body2,
  [theme.breakpoints.down("md")]: {
    fontSize: 16,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 14,
  },
}));

export const CalculatorButton = styled(Box)(({ theme }) => ({
  border: `1px solid ${colors.lightBorder}`,
  borderRadius: "10px",
  width: "fit-content",
  display: "flex",
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  cursor: "pointer",
  transition: "all 0.2s ease",
  marginTop: "auto",
  "&:hover": {
    backgroundColor: colors.hoverBg,
  },
}));

export const CalculatorButtonLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.spacing(2),
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 600,
}));

export const EastIcon = styled(East)({
  fontSize: "24px",
  color: colors.secondary,
});

export const CalculatorResult = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

export const CalculatorResultText = styled(Typography)(({ theme }) => ({
  fontFamily: "'Quicksand', sans-serif",
  fontSize: theme.spacing(2),
  fontWeight: 500,
  color: theme.palette.text.primary,
  display: "inline-block",
}));

export const BoldText = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  fontSize: "18px",
  fontWeight: 700,
});

export const TagsContainer = styled(Box)(({ theme }) => ({
  flexWrap: "wrap",
  display: "flex",
  gap: theme.spacing(1),
}));

export const Tag = styled(Box)(({ theme }) => ({
  border: `1px solid ${colors.lightBorder}`,
  borderRadius: "20px",
  width: "fit-content",
  display: "flex",
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 2),
}));

export const TagLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
  fontWeight: 500,
}));
